/**
 * Svetly/tmavy vzhled (P5, R.B. 6. 9.: "at je to vsude") - nezavisla dimenze
 * na produktovem tematu, `data-scheme` na <html> vedle `data-theme`.
 * Appka vlozi `schemeBootstrapScript` jako inline <script> PRED hydrataci
 * (do <head> statickeho `index.html`), aby prvni render uz mel spravny
 * atribut a nic neblikne (SSR/prvni render bez JS/localStorage).
 */
export const SCHEME_STORAGE_KEY = 'rh-scheme';
/** Cista logika pro runtime (SchemeSwitcher) - viz `schemeBootstrapImpl` nize pro ekvivalent v <script>. */
export function resolveScheme(stored, prefersDark) {
    if (stored === 'light')
        return null;
    if (stored === 'dark')
        return 'dark';
    return prefersDark ? 'dark' : null;
}
/**
 * Telo bootstrap <script>. MUSI byt soběstačné (žádné volání jiných funkcí
 * modulu, žádné uzávěry přes vnější proměnné) - `.toString()` serializuje
 * jen text teto funkce, spustí se detached v <head> webu bez zbytku modulu.
 * Logika je zaměrně duplikát `resolveScheme` (jen 3 řádky) z tohoto důvodu.
 * Testovatelné PŘÍMÝM voláním (žádný `new Function`/`eval` v testech) -
 * viz test/scheme-bootstrap.spec.ts.
 */
export function schemeBootstrapImpl(win, doc, storageKey) {
    try {
        const stored = win.localStorage.getItem(storageKey);
        const prefersDark = stored !== 'light' && (stored === 'dark' || (win.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false));
        if (prefersDark)
            doc.documentElement.setAttribute('data-scheme', 'dark');
    }
    catch {
        // localStorage nedostupna (private mode) / matchMedia chybi (stary prohlizec) - zustava svetle, bez padu.
    }
}
/**
 * Textovy zdroj pro <script> v <head> - serializace `schemeBootstrapImpl`
 * pres `.toString()` (zadny `new Function`/`eval`, jen nativni reflexe
 * funkce, kit build je prosty `tsc` bez minifikace, takze vystup je citelny
 * a stabilni pro rucni kopii do `index.html` jednotlivych appek (portal, gallery, kokpit).
 */
export const schemeBootstrapScript = `(${schemeBootstrapImpl.toString()})(window, document, ${JSON.stringify(SCHEME_STORAGE_KEY)});`;
//# sourceMappingURL=scheme-bootstrap.js.map